import axios from "axios";
import React, { useState, useEffect } from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Label, Row, Alert, Form } from "reactstrap";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { TextField } from "@mui/material";
import { showErrorToast } from "../../../_services/notification";
import { postMethod } from "../../../_services/_postMethod";
import CustomerFooter from "./components/footer";
import Loader from "../../modules/loader";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#000",
    backgroundColor: "#fff",
  },
  brandlogo: {
    maxWidth: "100%",
    height: "auto",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "110px",
      height: "110px",
    },
  },
}));

const CustUpdateInfo = (props) => {
  const classes = useStyles();

  const [info, setInfo] = useState({
    name: localStorage.getItem("jwl_username"),
    logo: localStorage.getItem("jwl_logo"),
    brand_name: localStorage.getItem("jwl_brand_name"),
    customer_id: localStorage.getItem("jwl_customer_id"),
    branch_id: localStorage.getItem("jwl_customer_branch_id"),
    mobile: localStorage.getItem("cust_mobile"),
  });

  const { register, handleSubmit } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [success, setSuccess] = useState(false);
  const [param, setParam] = useState({
    customer_id: info.customer_id == null ? 0 : info.customer_id,
    mobile: "",
    full_name: "",
    email: "",
    dob: null,
    doa: null,
    sp_bdy: null,
  });
  const [valid, setValid] = useState({
    mobile: true,
    email: true,
  });

  function redirect_after_submission() {
    const insta = localStorage.getItem("jwl_instagram");
    const facebook = localStorage.getItem("jwl_facebook");
    const twitter = localStorage.getItem("jwl_twitter");

    return insta
      ? window.open("https://www.instagram.com/" + insta, "_blank")
      : facebook
        ? window.open("https://www.facebook.com/" + facebook, "_blank")
        : twitter
          ? window.open("https://www.twitter.com/" + twitter, "_blank")
          : "";
  }

  const handlePhoneClick = () => {
    window.location.href = `tel:${localStorage.getItem("branch_contact")}`;
  };

  const insertData = () => {
    setLoadInsert(true);
    if (param.mobile === "") {
      showErrorToast("Please fill mobile.");
      setLoadInsert(false);
    } else if (param.mobile.length !== 10) {
      setValid({ ...valid, mobile: false });
      setLoadInsert(false);
    } else {
      postMethod("api/masters/customer/insert", param).then((data) => {
        if (data.data[0].valid) {
          setSuccess(true);
          setTimeout(() => {
            redirect_after_submission();
          }, 2000);
        } else {
          setLoadInsert(false);
        }
      });
    }
  };

  // ------------------
  useEffect(() => {
    if (info.customer_id !== null) {
      setLoad(true);
      postMethod("api/masters/customer/preview", { customer_id: info.customer_id }).then(
        (data) => {
          const d = data.data;
          setParam({
            ...param,
            customer_id: info.customer_id,
            mobile: d.mobile,
            email: d.email,
            dob: d.dob ? d.dob.split("T")[0] : null,
            doa: d.doa ? d.doa.split("T")[0] : null,
            full_name: d.full_name,
            sp_bdy: d.sp_bdy ? d.sp_bdy.split("T")[0] : null,
          });
          setLoad(false);
        }
      );
    }
  }, [info.customer_id]);

  // ---------------

  return (
    <div
      className="tag_wrapper"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Header with logo & call */}
      <div className="container d-flex justify-content-between align-items-center" style={{ padding: "10px" }}>
        <img
          className={`img-fluid ${classes.brandlogo}`}
          src={"https://api.quicktagg.com/BranchLogo/" + localStorage.getItem("jwl_logo")}
          style={{ maxHeight: "80px", objectFit: "contain" }}
          alt="Brand Logo"
        />
        <span className="btn" onClick={handlePhoneClick}>
          <PhoneIcon style={{ color: "blue", fontSize: "2rem" }} />
        </span>
      </div>

      {/* Content */}
      <div
        className="flex-grow-1 d-flex justify-content-center"
        style={{ padding: "15px", paddingBottom: "80px" }} // extra bottom padding so button not hidden by footer
      >
        <Card
          className="my-2 shadow-lg border-0"
          style={{
            width: "100%",
            maxWidth: "1000px",
            backgroundColor: "white",
            borderRadius: "15px",
            overflow: "hidden"
          }}
        >
          <CardHeader tag="h5" className="text-center" style={{ backgroundColor: "white", borderBottom: "1px solid rgba(0,0,0,0.1)", padding: "20px", fontWeight: "700", color: "#333" }}>
            Birthday & Anniversary Details
          </CardHeader>
          <div className="row no-gutters m-0 h-100">
            <div className="col-md-5 d-none d-md-flex align-items-center justify-content-center" style={{}}>
              <img src="/image.png" alt="Update Details" style={{ width: "100%", objectFit: "cover", minHeight: "0px" }} />
            </div>
            <div className="col-12 col-md-7 p-0">
              <CardBody style={{ padding: "30px", backgroundColor: "white" }}>
                {load ? <Loader /> : null}

                <Form onSubmit={handleSubmit(insertData)}>
                  <Row>
                    <Col md={12} className="mb-4">
                      <TextField
                        label="Full Name"
                        variant="outlined"
                        fullWidth
                        value={param.full_name || ""}
                        onChange={(e) => setParam({ ...param, full_name: e.target.value })}
                        inputRef={register}
                        name="full_name"
                        InputLabelProps={{ style: { fontWeight: 600, color: "#666" } }}
                        style={{ backgroundColor: "#fff" }}
                      />
                    </Col>

                    <Col md={12} className="mb-4">
                      <TextField
                        label="Mobile"
                        variant="outlined"
                        fullWidth
                        type="number"
                        value={param.mobile || ""}
                        onChange={(e) => setParam({ ...param, mobile: e.target.value })}
                        inputRef={register}
                        name="mobile"
                        required
                        InputLabelProps={{ style: { fontWeight: 600, color: "#666" } }}
                        style={{ backgroundColor: "#fff" }}
                        error={!valid.mobile}
                        helperText={!valid.mobile ? "Please enter a valid mobile" : ""}
                      />
                    </Col>

                    <Col md={12} className="mb-4">
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={param.email || ""}
                        onChange={(e) => setParam({ ...param, email: e.target.value })}
                        inputRef={register}
                        name="email"
                        InputLabelProps={{ style: { fontWeight: 600, color: "#666" } }}
                        style={{ backgroundColor: "#fff" }}
                      />
                    </Col>

                    <Col md={12} className="mb-4">
                      <TextField
                        label="Date of Birth"
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={param.dob || ""}
                        onChange={(e) => setParam({ ...param, dob: e.target.value })}
                        InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#666" } }}
                        style={{ backgroundColor: "#fff" }}
                      />
                    </Col>

                    <Col md={12} className="mb-4">
                      <TextField
                        label="Spouse's Birthday"
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={param.sp_bdy || ""}
                        onChange={(e) => setParam({ ...param, sp_bdy: e.target.value })}
                        InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#666" } }}
                        style={{ backgroundColor: "#fff" }}
                      />
                    </Col>

                    <Col md={12} className="mb-4">
                      <TextField
                        label="Date of Anniversary"
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={param.doa || ""}
                        onChange={(e) => setParam({ ...param, doa: e.target.value })}
                        InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#666" } }}
                        style={{ backgroundColor: "#fff" }}
                      />
                    </Col>
                  </Row>

                  {success ? <Alert color="success">Saved Successfully</Alert> : null}

                  <div className="text-right mt-4">
                    <Button className="btn btn-secondary mr-2" onClick={redirect_after_submission} style={{ padding: "10px 20px", borderRadius: "8px", fontWeight: "bold" }}>
                      Cancel
                    </Button>
                    {loadInser ? (
                      <Button className="btn btn-primary" style={{ padding: "10px 20px", borderRadius: "8px", fontWeight: "bold", backgroundColor: "#ffc107", color: "#333", border: "none" }}>
                        Saving..
                      </Button>
                    ) : (
                      <Button type="submit" className="btn btn-primary" style={{ padding: "10px 20px", borderRadius: "8px", fontWeight: "bold", backgroundColor: "#ffc107", color: "#333", border: "none" }}>
                        Save
                      </Button>
                    )}
                  </div>
                </Form>
              </CardBody>
            </div>
          </div>
        </Card>
      </div>

      {/* Fixed Footer */}
      <div style={{ position: "fixed", bottom: 0, left: 0, width: "100%" }}>
        <CustomerFooter />
      </div>
    </div>
  );
};

export default CustUpdateInfo;
